<template>
    <div class="row justify-content-center">
        <transition name="fade" mode="out-in">
            <AppPlaceholder class="col-xl-8" v-if="!company" key="no-company"/>
            <div v-else class="col-xl-8" key="company">
                <div class="row">
                    <div class="
                    col-12
                    mb-4
                    d-sm-flex
                    justify-content-sm-between
                    align-items-sm-start"
                    >
                        <div class="pl-3">
                            <h4>
                                {{ isNew ? 'New company' : company.name }}
                            </h4>
                            <p class="mb-0 text-muted" v-if="!isNew">
                                <small>Created on {{ company.created_at | date }}</small>
                            </p>
                        </div>
                        <div class="d-sm-flex col-12 col-sm-auto text-right pr-0 mt-2 mt-sm-0">
                            <button class="btn btn-primary mr-2" :disabled="loading" @click="save">
                                Save
                            </button>
                            <button class="btn btn-outline-secondary"
                                    :disabled="loading"
                                    @click="saveAndClose">
                                Save & close
                            </button>
                            <b-dropdown variant="link" no-caret right v-if="!isNew">
                                <template v-slot:button-content>
                                    <i class="material-icons">more_vert</i>
                                </template>
                                <b-dropdown-item :disabled="loading" @click="destroy">
                                    Delete
                                </b-dropdown-item>
                            </b-dropdown>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <p class="col-12 text-muted mb-3"><strong>General</strong></p>
                        </div>
                        <div class="row">
                            <AppInput
                                    label="Name"
                                    :value="company.name"
                                    field="name"
                                    :errors="errors"
                                    @change="updateCompanyProps({ name: $event })"
                                    class="col-md-7"
                            />
                            <AppSelect
                                    :value="company.types"
                                    :multiple="true"
                                    :options="companyTypes"
                                    track-by="code"
                                    label-field="name"
                                    label="Type"
                                    placeholder=""
                                    @input="updateCompanyProps(
                                    { type_code: $event ? $event.id : null, types: $event })"
                                    class="col-md-5"
                            />
                        </div>
                        <div class="row">
                            <AppInput
                                    label="Reg number"
                                    :value="company.reg_no"
                                    field="reg_no"
                                    :errors="errors"
                                    @change="updateCompanyProps({ reg_no: $event })"
                                    class="col-md-4"
                            />
                            <AppInput
                                    label="Vat number"
                                    :value="company.vat_no"
                                    field="vat_no"
                                    :errors="errors"
                                    @change="updateCompanyProps({ vat_no: $event })"
                                    class="col-md-4"
                            />
                            <AppInput
                                    label="License number"
                                    :value="company.license_no"
                                    field="license_no"
                                    :errors="errors"
                                    @change="updateCompanyProps({ license_no: $event })"
                                    class="col-md-4"
                            />
                        </div>
                        <div class="row">
                            <AppSelect
                                    :value="company.location"
                                    :options="locationSuggestions"
                                    :allow-empty="true"
                                    field="location_id"
                                    track-by="id"
                                    :errors="errors"
                                    label-field="name"
                                    :preserve-search="false"
                                    label="Location"
                                    placeholder=""
                                    @search-change="suggestLocations"
                                    @input="
                                          updateCompanyProps({
                                            location_id: $event ? $event.id : null,
                                            location: $event
                                          })
                                        "
                                    class="col-md-11"
                            >
                                <template slot="noResult">
                                    <button
                                            @click="addLocation"
                                            class="col-sm-12 btn btn-link"
                                    >
                                        Add Location
                                    </button>
                                </template>
                            </AppSelect>
                        </div>
                        <div class="row">
                            <p class="col-12 text-muted mb-3">
                                <strong>Additional information</strong>
                            </p>
                        </div>
                        <div class="row">
                            <AppTextArea
                                    label="Notes"
                                    :value="company.notes"
                                    field="notes"
                                    :errors="errors"
                                    @change="updateCompanyProps({ notes: $event })"
                                    class="col-12"
                                    max="250"
                            />
                        </div>
                        <div class="row">
                            <p class="col-12 text-muted mb-3"><strong>Contact</strong></p>
                        </div>
                        <div class="row">
                            <AppInput
                                    label="Company email"
                                    :value="company.email"
                                    field="email"
                                    :errors="errors"
                                    @change="updateCompanyProps({ email: $event })"
                                    class="col-md-6"
                            />
                        </div>
                        <!-- Contacts -->
                        <div class="row">
                            <p class="col-12 text-muted mb-3">
                                <strong>Contacts</strong>
                            </p>
                        </div>
                        <div
                                class="d-sm-flex justify-content-sm-between align-items-sm-baseline"
                                v-if="!isNew && company"
                        >
                            <AppSelect
                                    :value="null"
                                    :options="userSuggestions"
                                    field="contact_user"
                                    track-by="id"
                                    label-field="name"
                                    placeholder="Find & assign contact to company"
                                    @search-change="suggestUsers($event)"
                                    class="mr-2"
                                    @input="assignUserToCompany($event ? $event.id : null)"
                            />
                            <button class="btn btn-sm btn-secondary"
                                    :disabled="loading"
                                    @click="addUser">
                                Add contact
                            </button>
                        </div>
                        <div class="row table-responsive">
                            <UsersList
                                    :company="company"
                                    :show-header="false"
                                    @on-assign-user="
                              updateCompanyProps({
                                default_contact_user_id: $event ? $event.id : null,
                                default_contact_user: $event
                              })
                            "
                            />
                        </div>
                    </div>
                </div>
                <CompanyUserModal/>
                <LocationModal/>
            </div>
        </transition>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import debounce from 'lodash.debounce';
import { BDropdown, BDropdownItem } from 'bootstrap-vue';
import NotificationService from '../../services/notification.service';
import AppInput from '../form/AppInput';
import AppSelect from '../form/AppSelect';
import AppPlaceholder from '../form/AppPlaceholder';
import AppTextArea from '../form/AppTextarea';
import Errors from '../../utils/errors';
import { formatDate } from '../../filters/date.filter';
import UsersList from '../users/UsersList';
import CompanyUserModal from './CompanyUserModal';
import LocationModal from '../locations/LocationModal';

export default {
  components: {
    UsersList,
    AppInput,
    AppPlaceholder,
    AppTextArea,
    AppSelect,
    CompanyUserModal,
    BDropdown,
    BDropdownItem,
    LocationModal,
  },
  data() {
    return {
      errors: new Errors(),
      contactUserSuggestions: [],
      locationSuggestions: [],
      userSuggestions: [],
      // regionSuggestions: [],
      loading: false,
      canClose: false,
    };
  },
  filters: {
    date: formatDate,
  },
  computed: {
    ...mapGetters({
      company: 'companies/company',
      companyTypes: 'companies/companyTypes',
      countries: 'orders/countries',
    }),
    isNew() {
      return this.$route.params.id === 'new';
    },
  },
  mounted() {
    this.initCompany();
  },
  watch: {
    '$route.params.id'() {
      this.initCompany();
    },
  },
  methods: {
    // Start process of adding new location
    addLocation() {
      this.$store.dispatch('locations/openLocationModal', { type: 'company' }).then((res) => {
        this.updateCompanyProps({
          location_id: res.id,
          location: res,
        });
      });
    },
    suggestLocations: debounce(function suggest(query) {
      return this.$store
        .dispatch('locations/suggestLocations', {
          query,
          type: 'company',
        })
        .then((suggestions) => {
          this.locationSuggestions = suggestions;
        });
    }, 300),
    initCompany() {
      if (this.isNew) {
        this.$store.dispatch('companies/newCompany');
      } else {
        this.getCompany();
      }
      this.$store.dispatch('companies/getCompanyTypes');
    },
    suggestContactUsers: debounce(function suggest(query) {
      return this.$store
        .dispatch('users/suggestUsers', {
          query,
          company_id: this.company.id,
        })
        .then((suggestions) => {
          this.contactUserSuggestions = suggestions;
        });
    }, 300),
    suggestUsers: debounce(function suggest(query) {
      return this.$store
        .dispatch('users/suggestUsers', {
          query,
        })
        .then((suggestions) => {
          this.userSuggestions = suggestions;
        });
    }, 300),
    addUser() {
      const props = {
        id: null,
        isNewUser: true,
        companyId: this.company.id,
      };
      this.$store.dispatch('users/openUserModal', props);
    },
    getCompany() {
      this.$store.dispatch('companies/getCompany', this.$route.params.id);
    },
    // getCurrencies() {
    //   this.$store.dispatch('currencyRates/getCurrencies');
    // },
    assignUserToCompany(props) {
      this.$store.dispatch('companies/assignUserToCompany', props);
    },
    updateCompanyProps(props) {
      this.$store.dispatch('companies/updateCompanyProps', props);
    },
    saveAndClose() {
      this.save()
        .then(() => {
          if (this.canClose) {
            this.$router.push({ name: 'companies' });
          }
        });
    },
    save() {
      this.loading = true;
      this.errors.clear();
      return this.$store
        .dispatch(this.isNew ? 'companies/createCompany' : 'companies/updateCompany')
        .then((res) => {
          this.canClose = true;
          if (this.isNew) {
            this.$router.push({
              name: 'company',
              params: { id: res.company_id },
            });
          }
          NotificationService.success(res.message);
        })
        .catch((err) => {
          this.canClose = false;
          this.errors.set(err.response.data.errors);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    destroy() {
      this.$bvModal
        .msgBoxConfirm('Delete company?', {
          okTitle: 'Delete',
          okVariant: 'danger',
        })
        .then((value) => {
          if (value) {
            this.$store.dispatch('companies/deleteCompany')
              .then((res) => {
                NotificationService.success(res.message);
                this.$router.push({ name: 'companies' });
              });
          }
        });
    },
  },
};
</script>
